export default __webpack_public_path__ + "static/media/promo_02.158e79f0.jpg";